module.exports = __webpack_public_path__ + "static/img/player_02_ph.89b028e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_02_ph.png
// module id = PbCG
// module chunks = 0